// src/pages/DashboardPadre.js

import React, { useState, useEffect, useCallback } from 'react';
import apiClient from '../services/api';
import { toast } from 'react-toastify';
import Card from '../components/Card';
import Button from '../components/Button';
import GestionRecompensas from '../components/GestionRecompensas';
import CrearHijoModal from '../components/CrearHijoModal';
import EditarTareaModal from '../components/EditarTareaModal';
import RechazarTareaModal from '../components/RechazarTareaModal'; // <-- Importamos el nuevo modal
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { FaEdit, FaTrash, FaCheck, FaGift, FaUndo } from 'react-icons/fa';

// --- (Modal de Crear Tarea sin cambios) ---
function CrearTareaModal({ ninos, onClose, onTareaCreada }) {
    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [puntos, setPuntos] = useState(10);
    const [categoria, setCategoria] = useState('HOGAR');
    const [asignadaA, setAsignadaA] = useState(ninos.length > 0 ? ninos[0].id : '');
    const [tipo, setTipo] = useState('UNICA');
    const [error, setError] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const nuevaTarea = { tipo, titulo, descripcion, puntos, categoria, asignada_a: asignadaA };
            await apiClient.post('/tareas/', nuevaTarea);
            toast.success(`¡Tarea "${titulo}" creada! ✨`);
            onTareaCreada();
            onClose();
        } catch (err) { setError('No se pudo crear la tarea.'); }
    };
    return (<div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"><div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md"><h2 className="text-2xl font-bold text-principal mb-6">Crear Tarea Mágica 🪄</h2><form onSubmit={handleSubmit}><div className="mb-4"><label className="block text-gray-700 font-bold mb-2">Tipo de Tarea</label><select value={tipo} onChange={(e) => setTipo(e.target.value)} className="w-full px-3 py-2 border rounded-lg bg-white"><option value="UNICA">Tarea Única</option><option value="RECURRENTE">Hábito (Recurrente)</option></select></div><div className="mb-4"><label className="block text-gray-700 font-bold mb-2">Título</label><input type="text" value={titulo} onChange={(e) => setTitulo(e.target.value)} className="w-full px-3 py-2 border rounded-lg" required /></div><div className="mb-4"><label className="block text-gray-700 font-bold mb-2">Descripción</label><textarea value={descripcion} onChange={(e) => setDescripcion(e.target.value)} className="w-full px-3 py-2 border rounded-lg" rows="2"></textarea></div><div className="grid grid-cols-2 gap-4 mb-4"><div><label className="block text-gray-700 font-bold mb-2">Puntos ✨</label><input type="number" value={puntos} onChange={(e) => setPuntos(e.target.value)} className="w-full px-3 py-2 border rounded-lg" required min="1" /></div><div><label className="block text-gray-700 font-bold mb-2">Categoría</label><select value={categoria} onChange={(e) => setCategoria(e.target.value)} className="w-full px-3 py-2 border rounded-lg bg-white"><option value="HOGAR">Hogar</option><option value="ESCUELA">Escuela</option><option value="HABITOS">Hábitos</option></select></div></div><div className="mb-6"><label className="block text-gray-700 font-bold mb-2">Asignada a:</label><select value={asignadaA} onChange={(e) => setAsignadaA(e.target.value)} className="w-full px-3 py-2 border rounded-lg bg-white" required>{ninos.map(nino => (<option key={nino.id} value={nino.id}>{nino.username}</option>))}</select></div>{error && <p className="text-red-500 text-sm mb-4">{error}</p>}<div className="flex justify-end gap-4"><Button type="button" variant="secondary" onClick={onClose}>Cancelar</Button><Button type="submit" variant="accent">Crear Tarea</Button></div></form></div></div>);
}

// --- Componente para la Pestaña de Tareas ---
function GestionTareas({ ninos, onApproveTask, onApproveHabit, onEditTask, onDeleteTask, onUndoApproveTask, onUndoApproveHabit, onRejectTask, onRejectHabit }) {
    const [tareas, setTareas] = useState([]);
    const [registrosHabitosPendientes, setRegistrosHabitosPendientes] = useState([]);
    const [historial, setHistorial] = useState([]);
    const [showRechazarModal, setShowRechazarModal] = useState(false);
    const [itemARechazar, setItemARechazar] = useState(null);
  
    const fetchAllData = useCallback(async () => {
      try {
          const [tareasRes, registrosRes, historialRes] = await Promise.all([
            apiClient.get('/tareas/'),
            apiClient.get('/registros-habito/'),
            apiClient.get('/historial/')
          ]);
          setTareas(tareasRes.data);
          setRegistrosHabitosPendientes(registrosRes.data);
          setHistorial(historialRes.data);
        } catch (error) { console.error("Error cargando datos de gestión", error); }
    }, []);
  
    useEffect(() => {
      fetchAllData();
      const interval = setInterval(fetchAllData, 20000);
      return () => clearInterval(interval);
    }, [fetchAllData]);
    
    const handleOpenRechazar = (item, tipo) => {
        setItemARechazar({ ...item, itemTipo: tipo });
        setShowRechazarModal(true);
    };

    const handleConfirmarRechazo = (comentario) => {
        if (itemARechazar.itemTipo === 'tarea') {
            onRejectTask(itemARechazar.id, comentario);
        } else if (itemARechazar.itemTipo === 'habito') {
            onRejectHabit(itemARechazar.id, comentario);
        }
    };
  
    const tareasPorAprobar = tareas.filter(t => t.status === 'COMPLETADA');
    const totalPendientes = tareasPorAprobar.length + registrosHabitosPendientes.length;
    const tareasEnCurso = tareas.filter(t => t.tipo === 'RECURRENTE' || (t.tipo === 'UNICA' && t.status !== 'APROBADA'));
  
    return (
    <>
      {showRechazarModal && (
        <RechazarTareaModal
          tareaTitulo={itemARechazar.titulo || (itemARechazar.tarea && itemARechazar.tarea.titulo)}
          onClose={() => setShowRechazarModal(false)}
          onConfirmarRechazo={handleConfirmarRechazo}
        />
      )}
      <Tabs>
          <TabList>
              <Tab>Por Aprobar ({totalPendientes})</Tab>
              <Tab>Tareas en Curso ({tareasEnCurso.length})</Tab>
              <Tab>Historial</Tab>
          </TabList>
  
          <TabPanel>
            <div className="mt-6 space-y-4">
                {totalPendientes > 0 ? (
                    <>
                        {tareasPorAprobar.map(tarea => (
                            <div key={`tarea-${tarea.id}`} className="bg-white p-4 rounded-lg shadow-sm flex justify-between items-center">
                                <div><p className="font-bold">{tarea.titulo}</p><p className="text-sm text-gray-500">Completada por: {ninos.find(n => n.id === tarea.asignada_a)?.username}</p></div>
                                <div className="flex items-center gap-2">
                                    <Button variant="danger" size="sm" onClick={() => handleOpenRechazar(tarea, 'tarea')}>Rechazar</Button>
                                    <Button variant="success" size="sm" onClick={() => onApproveTask(tarea.id)}>Aprobar</Button>
                                </div>
                            </div>
                        ))}
                        {registrosHabitosPendientes.map(registro => {
                            const tareaAsociada = tareas.find(t => t.id === registro.tarea);
                            if (!tareaAsociada) return null;
                            return (
                                <div key={`habito-${registro.id}`} className="bg-blue-50 p-4 rounded-lg shadow-sm flex justify-between items-center">
                                    <div><p className="font-bold">{tareaAsociada.titulo} <span className="font-normal text-gray-500">- {new Date(registro.fecha + 'T00:00:00').toLocaleDateString('es-ES', { weekday: 'long' })}</span></p><p className="text-sm text-gray-500">Completado por: {ninos.find(n => n.id === tareaAsociada.asignada_a)?.username}</p></div>
                                    <div className="flex items-center gap-2">
                                        <Button variant="danger" size="sm" onClick={() => handleOpenRechazar({ ...registro, tarea: tareaAsociada }, 'habito')}>Rechazar</Button>
                                        <Button variant="success" size="sm" onClick={() => onApproveHabit(registro.id)}>Aprobar</Button>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                ) : <p className="text-gray-500 bg-white p-4 rounded-lg">No hay nada pendiente de aprobación.</p>}
            </div>
          </TabPanel>
  
          <TabPanel>
            <div className="mt-6 space-y-3">
                {tareasEnCurso.length > 0 ? tareasEnCurso.map(tarea => (
                    <Card key={tarea.id} className="flex justify-between items-center p-4">
                        <div>
                            <p className="font-bold">{tarea.titulo} <span className={`text-sm font-normal px-2 py-1 rounded-full ${tarea.tipo === 'UNICA' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'}`}>{tarea.tipo === 'UNICA' ? 'Única' : 'Hábito'}</span></p>
                            <p className="text-sm text-gray-500">Asignada a: {ninos.find(n => n.id === tarea.asignada_a)?.username}</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <Button variant="secondary" onClick={() => onEditTask(tarea)}><FaEdit /></Button>
                            <Button variant="danger" onClick={() => onDeleteTask(tarea.id)}><FaTrash /></Button>
                        </div>
                    </Card>
                )) : <p className="text-gray-500 bg-white p-4 rounded-lg">No hay tareas o hábitos en curso.</p>}
            </div>
          </TabPanel>
  
          <TabPanel>
            <div className="mt-6 space-y-3">
                {historial.length > 0 ? historial.slice(0, 20).map(item => {
                    const isTask = item.tipo === 'TAREA';
                    return (
                        <Card key={item.id} className="flex justify-between items-center p-4 opacity-80">
                            <div className='flex items-center gap-3'>{isTask ? <FaCheck className='text-green-500'/> : <FaGift className='text-yellow-500'/> }<div><p className="font-semibold">{item.descripcion}</p><p className="text-sm text-gray-500">{new Date(item.fecha).toLocaleString('es-ES')} - {ninos.find(n => n.id === item.usuario)?.username}</p></div></div>
                            <div className="flex items-center gap-2"><span className={`font-bold ${item.puntos > 0 ? 'text-green-600' : 'text-red-600'}`}>{item.puntos > 0 ? `+${item.puntos}` : item.puntos} Pts</span>{isTask && (<Button variant="secondary" onClick={() => {
                                        const tareaOriginal = tareas.find(t => t.tipo === 'UNICA' && `Completaste la tarea: "${t.titulo}"` === item.descripcion && t.asignada_a === item.usuario && t.status === 'APROBADA');
                                        let registroOriginal = null;
                                        if (!tareaOriginal) {
                                            const fechaHistorial = new Date(item.fecha).toISOString().split('T')[0];
                                            for (const tarea of tareas) {
                                                if (tarea.tipo === 'RECURRENTE' && `Completaste el hábito: "${tarea.titulo}"` === item.descripcion && tarea.asignada_a === item.usuario) {
                                                    const registro = (tarea.registros_semana || []).find(r => r.fecha === fechaHistorial && r.aprobado);
                                                    if (registro) { registroOriginal = registro; break; }
                                                }
                                            }
                                        }
                                        if (tareaOriginal) { onUndoApproveTask(tareaOriginal.id); } 
                                        else if (registroOriginal) { onUndoApproveHabit(registroOriginal.id); } 
                                        else { toast.warn("No se pudo encontrar la acción original para revertir."); }
                                    }}><FaUndo title="Deshacer aprobación"/></Button>)}</div>
                        </Card>
                    );
                }) : <p className="text-gray-500 bg-white p-4 rounded-lg">Aún no hay actividad en el historial.</p>}
            </div>
          </TabPanel>
      </Tabs>
    </>
    );
}

// --- Componente Principal del Dashboard ---
function DashboardPadre() {
  const [usuario, setUsuario] = useState(null);
  const [ninos, setNinos] = useState([]);
  const [showCrearModal, setShowCrearModal] = useState(false);
  const [showEditarModal, setShowEditarModal] = useState(false);
  const [tareaSeleccionada, setTareaSeleccionada] = useState(null);
  const [showHijoModal, setShowHijoModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dataVersion, setDataVersion] = useState(0);
  const forceUpdate = () => setDataVersion(v => v + 1);

  useEffect(() => {
    const fetchInitialData = async () => {
        setLoading(true);
        try {
          const [perfilRes, ninosRes] = await Promise.all([apiClient.get('/perfil/'), apiClient.get('/familia/ninos/')]);
          setUsuario(perfilRes.data);
          setNinos(ninosRes.data);
        } catch (error) { console.error("Error cargando datos:", error); } 
        finally { setLoading(false); }
    };
    fetchInitialData();
  }, [dataVersion]);

  const handleApproveTask = async (tareaId) => {
    try { await apiClient.post(`/tareas/${tareaId}/aprobar/`); toast.success('¡Tarea aprobada!'); forceUpdate(); } 
    catch (error) { toast.error('Error al aprobar la tarea.'); }
  };
  const handleApproveHabit = async (registroId) => {
    try { await apiClient.post(`/registros-habito/${registroId}/aprobar/`); toast.success('¡Hábito aprobado!'); forceUpdate(); } 
    catch (error) { toast.error('Error al aprobar el hábito.'); }
  };
  const handleEditTask = (tarea) => { setTareaSeleccionada(tarea); setShowEditarModal(true); };
  const handleDeleteTask = async (tareaId) => {
    if (window.confirm('¿Seguro que quieres eliminar?')) {
      try { await apiClient.delete(`/tareas/${tareaId}/`); toast.success('Tarea eliminada.'); forceUpdate(); } 
      catch (error) { toast.error('Error al eliminar la tarea.'); }
    }
  };
  const handleUndoApproveTask = async (tareaId) => {
    if (window.confirm("¿Revertir la aprobación? Los puntos serán restados.")) {
      try { await apiClient.post(`/tareas/${tareaId}/desaprobar/`); toast.success('Aprobación revertida.'); forceUpdate(); } 
      catch (error) { toast.error('No se pudo revertir la aprobación.'); }
    }
  };
  const handleUndoApproveHabit = async (registroId) => {
    if (window.confirm("¿Revertir la aprobación? Los puntos serán restados.")) {
       try { await apiClient.post(`/registros-habito/${registroId}/desaprobar/`); toast.success('Aprobación de hábito revertida.'); forceUpdate(); } 
       catch (error) { toast.error('No se pudo revertir la aprobación.'); }
    }
  };

  const handleRejectTask = async (tareaId, comentario) => {
    try {
      await apiClient.post(`/tareas/${tareaId}/rechazar/`, { comentario });
      toast.info('Tarea devuelta al niño.');
      forceUpdate();
    } catch (error) {
      toast.error('No se pudo rechazar la tarea.');
    }
  };

  const handleRejectHabit = async (registroId, comentario) => {
    try {
      await apiClient.post(`/registros-habito/${registroId}/rechazar/`, { comentario });
      toast.info('Hábito devuelto al niño.');
      forceUpdate();
    } catch (error) {
      toast.error('No se pudo rechazar el hábito.');
    }
  };

  if (loading) return <div className="p-8 text-center text-xl">Cargando...</div>;

  return (
    <div className="p-8">
      {showHijoModal && (<CrearHijoModal onClose={() => setShowHijoModal(false)} onHijoCreado={forceUpdate} />)}
      {showCrearModal && <CrearTareaModal ninos={ninos} onClose={() => setShowCrearModal(false)} onTareaCreada={forceUpdate} />}
      {showEditarModal && <EditarTareaModal tarea={tareaSeleccionada} ninos={ninos} onClose={() => setShowEditarModal(false)} onTareaActualizada={forceUpdate} />}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <Card>
    <h2 className="text-xl font-bold mb-2">Tu Familia 🏡</h2>
    <p className="text-gray-500 mb-2">Código de invitación:</p>
    <div className="bg-principal bg-opacity-20 text-principal font-mono text-center p-3 rounded-lg font-bold text-lg mb-4">
        {usuario?.codigo_familia}
    </div>
    
    {/* --- BOTÓN NUEVO --- */}
    <div className="border-t pt-4">
        <Button 
            variant="secondary" 
            className="w-full text-sm py-2"
            onClick={() => setShowHijoModal(true)}
        >
            + Añadir Hijo Manualmente
        </Button>
    </div>
</Card>
        
        <Card className="bg-acento text-black flex flex-col justify-center items-center"><h2 className="text-2xl font-bold mb-3">¿Nueva Aventura?</h2><button onClick={() => setShowCrearModal(true)} className="bg-white text-acento font-bold py-3 px-6 rounded-full text-lg shadow-lg hover:scale-105 transition-transform">+ Crear Tarea</button></Card>
      </div>
      <Tabs>
        <TabList>
          <Tab>Gestión de Tareas</Tab>
          <Tab>Gestión de Recompensas</Tab>
        </TabList>
        <TabPanel>
          <div className="mt-6">
            <GestionTareas 
              key={dataVersion} 
              ninos={ninos} 
              onApproveTask={handleApproveTask} 
              onApproveHabit={handleApproveHabit} 
              onEditTask={handleEditTask} 
              onDeleteTask={handleDeleteTask}
              onUndoApproveTask={handleUndoApproveTask}
              onUndoApproveHabit={handleUndoApproveHabit}
              onRejectTask={handleRejectTask}
              onRejectHabit={handleRejectHabit}
            />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="mt-6"><GestionRecompensas /></div>
        </TabPanel>
      </Tabs>
    </div>
  );
}

export default DashboardPadre;